module.exports = __webpack_public_path__ + "media/images/common/apple-sign-in-8d7254215a664017221acfa5691e329e.png";